// © Microsoft Corporation. All rights reserved.

/** The pdp query enums */
export enum TargetType {

    /** Weather location */
    Location = "Location",

    /** Finance */
    Finance = "Finance",

    /** Sports team */
    Team = "Team",

    /** Sports league */
    League = "League",

    /** Sports layer */
    Player = "Player"
}